import { CALL_API, CONTENT_TYPE } from 'middlewares/api';
import fetchData from 'utils/api';
import { url } from 'configs/';
import { buildPageMeta } from 'containers/App/screens/Tube/utils';
import { downloadFile } from 'containers/App/screens/Tube/utils/downloadFile';

const { NEWTUBE_API_SERVER } = url;

const FETCH_MANAGEMENT_NEWSCATEGORY_REQUEST =
  'tube/companynews/management/FETCH_MANAGEMENT_NEWSCATEGORY_REQUEST';
const FETCH_MANAGEMENT_NEWSCATEGORY_SUCCESS =
  'tube/companynews/management/FETCH_MANAGEMENT_NEWSCATEGORY_SUCCESS';
const FETCH_MANAGEMENT_NEWSCATEGORY_FAILURE =
  'tube/companynews/management/FETCH_MANAGEMENT_NEWSCATEGORY_FAILURE';
const FETCH_MANAGEMENT_NEWSLIST_REQUEST =
  'tube/companynews/management/FETCH_MANAGEMENT_NEWSLIST_REQUEST';
const FETCH_MANAGEMENT_NEWSLIST_SUCCESS =
  'tube/companynews/management/FETCH_MANAGEMENT_NEWSLIST_SUCCESS';
const FETCH_MANAGEMENT_NEWSLIST_FAILURE =
  'tube/companynews/management/FETCH_MANAGEMENT_NEWSLIST_FAILURE';
const FETCH_MANAGEMENT_NEWS_REQUEST =
  'tube/companynews/management/FETCH_MANAGEMENT_NEWS_REQUEST';
const FETCH_MANAGEMENT_NEWS_SUCCESS =
  'tube/companynews/management/FETCH_MANAGEMENT_NEWS_SUCCESS';
const FETCH_MANAGEMENT_NEWS_FAILURE =
  'tube/companynews/management/FETCH_MANAGEMENT_NEWS_FAILURE';
const FETCH_MANAGEMENT_NEWS_PERMISSION_REQUEST =
  'tube/companynews/management/FETCH_MANAGEMENT_NEWS_PERMISSION_REQUEST';
const FETCH_MANAGEMENT_NEWS_PERMISSION_SUCCESS =
  'tube/companynews/management/FETCH_MANAGEMENT_NEWS_PERMISSION_SUCCESS';
const FETCH_MANAGEMENT_NEWS_PERMISSION_FAILURE =
  'tube/companynews/management/FETCH_MANAGEMENT_NEWS_PERMISSION_FAILURE';
const POST_MANAGEMENT_NEWS_REQUEST =
  'tube/companynews/management/POST_MANAGEMENT_NEWS_REQUEST';
const POST_MANAGEMENT_NEWS_SUCCESS =
  'tube/companynews/management/POST_MANAGEMENT_NEWS_SUCCESS';
const POST_MANAGEMENT_NEWS_FAILURE =
  'tube/companynews/management/POST_MANAGEMENT_NEWS_FAILURE';
const PUT_MANAGEMENT_NEWS_REQUEST =
  'tube/companynews/management/PUT_MANAGEMENT_NEWS_REQUEST';
const PUT_MANAGEMENT_NEWS_SUCCESS =
  'tube/companynews/management/PUT_MANAGEMENT_NEWS_SUCCESS';
const PUT_MANAGEMENT_NEWS_FAILURE =
  'tube/companynews/management/PUT_MANAGEMENT_NEWS_FAILURE';
const DELETE_MANAGEMENT_NEWS_REQUEST =
  'tube/companynews/management/DELETE_MANAGEMENT_NEWS_REQUEST';
const DELETE_MANAGEMENT_NEWS_SUCCESS =
  'tube/companynews/management/DELETE_MANAGEMENT_NEWS_SUCCESS';
const DELETE_MANAGEMENT_NEWS_FAILURE =
  'tube/companynews/management/DELETE_MANAGEMENT_NEWS_FAILURE';
const UPLOAD_MANAGEMENT_NEWSFILE_REQUEST =
  'tube/companynews/management/UPLOAD_MANAGEMENT_NEWSFILE_REQUEST';
const UPLOAD_MANAGEMENT_NEWSFILE_SUCCESS =
  'tube/companynews/management/UPLOAD_MANAGEMENT_NEWSFILE_SUCCESS';
const UPLOAD_MANAGEMENT_NEWSFILE_FAILURE =
  'tube/companynews/management/UPLOAD_MANAGEMENT_NEWSFILE_FAILURE';
const FETCH_MANAGEMENT_ENROLLMENT_REQUEST =
  'tube/companynews/management/FETCH_MANAGEMENT_ENROLLMENT_REQUEST';
const FETCH_MANAGEMENT_ENROLLMENT_SUCCESS =
  'tube/companynews/management/FETCH_MANAGEMENT_ENROLLMENT_SUCCESS';
const FETCH_MANAGEMENT_ENROLLMENT_FAILURE =
  'tube/companynews/management/FETCH_MANAGEMENT_ENROLLMENT_FAILURE';
const DELETE_MANAGEMENT_NEWSFILE_REQUEST =
  'tube/companynews/management/DELETE_MANAGEMENT_NEWSFILE_REQUEST';
const DELETE_MANAGEMENT_NEWSFILE_SUCCESS =
  'tube/companynews/management/DELETE_MANAGEMENT_NEWSFILE_SUCCESS';
const DELETE_MANAGEMENT_NEWSFILE_FAILURE =
  'tube/companynews/management/DELETE_MANAGEMENT_NEWSFILE_FAILURE';
const GET_DOWNLOADEXCEL_MANAGEMENTENROLLMENT_REQUEST =
  'tube/companynews/management/GET_DOWNLOADEXCEL_MANAGEMENTENROLLMENT_REQUEST';
const GET_DOWNLOADEXCEL_MANAGEMENTENROLLMENT_SUCCESS =
  'tube/companynews/management/GET_DOWNLOADEXCEL_MANAGEMENTENROLLMENT_SUCCESS';
const GET_DOWNLOADEXCEL_MANAGEMENTENROLLMENT_ERROR =
  'tube/companynews/management/GET_DOWNLOADEXCEL_MANAGEMENTENROLLMENT_ERROR';

export default function reducer(
  state = {
    error: {},
    news: {},
    newsCategoryList: [],
    newsList: [],
    newsListMeta: {},
    newsPermission: [],
    isListLoading: false,
    isLoading: false,
  },
  action
) {
  switch (action.type) {
    case FETCH_MANAGEMENT_NEWSCATEGORY_SUCCESS: {
      const list = action.response.data;
      return Object.assign({}, state, {
        newsCategoryList: list,
      });
    }
    case FETCH_MANAGEMENT_NEWSCATEGORY_FAILURE:
    case FETCH_MANAGEMENT_NEWS_FAILURE:
    case FETCH_MANAGEMENT_NEWS_PERMISSION_FAILURE:
    case POST_MANAGEMENT_NEWS_FAILURE:
    case PUT_MANAGEMENT_NEWS_FAILURE:
    case DELETE_MANAGEMENT_NEWS_FAILURE: {
      return Object.assign({}, state, {
        error: action.error,
        isLoading: false,
      });
    }
    case FETCH_MANAGEMENT_NEWSLIST_REQUEST: {
      return Object.assign({}, state, { isListLoading: true });
    }
    case FETCH_MANAGEMENT_NEWSLIST_SUCCESS: {
      const list = action.response.data;
      const meta = buildPageMeta(action.response.meta);
      return Object.assign({}, state, {
        newsList: list,
        isListLoading: false,
        newsListMeta: meta,
      });
    }
    case FETCH_MANAGEMENT_NEWSLIST_FAILURE: {
      return Object.assign({}, state, {
        error: action.error,
        isListLoading: false,
      });
    }
    case FETCH_MANAGEMENT_NEWS_REQUEST:
    case FETCH_MANAGEMENT_NEWS_PERMISSION_REQUEST:
    case FETCH_MANAGEMENT_ENROLLMENT_REQUEST: {
      return Object.assign({}, state, {
        isLoading: true,
      });
    }
    case FETCH_MANAGEMENT_NEWS_SUCCESS:
    case FETCH_MANAGEMENT_ENROLLMENT_SUCCESS: {
      const data = action.response.data;
      return Object.assign({}, state, {
        isLoading: false,
        news: data,
      });
    }
    case FETCH_MANAGEMENT_NEWS_PERMISSION_SUCCESS: {
      const data = action.response.data;
      return Object.assign({}, state, {
        isLoading: false,
        newsPermission: data,
      });
    }
    default:
      return state;
  }
}

/* 取得 消息管理 分類列表 */
export function fetchManagementNewsCategory() {
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER + 'NewsCompany/AnnouncementCategory/Management',
      method: 'GET',
      headers: {
        functionCode: 'AnnouncementHR',
        actionCode: 'Manage',
      },
      types: [
        FETCH_MANAGEMENT_NEWSCATEGORY_REQUEST,
        FETCH_MANAGEMENT_NEWSCATEGORY_SUCCESS,
        FETCH_MANAGEMENT_NEWSCATEGORY_FAILURE,
      ],
    },
  };
}

/* 列表消息查詢(管理畫面) */
export function fetchManagementNewsList(announcementCategoryId, pageNumber) {
  return {
    [CALL_API]: {
      url: `${NEWTUBE_API_SERVER}NewsCompany/Announcement/Management?AnnouncementCategoryId=${announcementCategoryId}&pageNumber=${pageNumber}`,
      method: 'GET',
      headers: {
        functionCode: 'AnnouncementHR',
        actionCode: 'Manage',
      },
      types: [
        FETCH_MANAGEMENT_NEWSLIST_REQUEST,
        FETCH_MANAGEMENT_NEWSLIST_SUCCESS,
        FETCH_MANAGEMENT_NEWSLIST_FAILURE,
      ],
    },
  };
}

/* 消息權限查詢單筆(檢視權限畫面) */
export function fetchManagementNewsPermission(announcementId) {
  return {
    [CALL_API]: {
      url: `${NEWTUBE_API_SERVER}NewsCompany/Announcement/Management/Permissions/${announcementId}`,
      method: 'GET',
      headers: {
        functionCode: 'AnnouncementHR',
        actionCode: 'Manage',
      },
      types: [
        FETCH_MANAGEMENT_NEWS_PERMISSION_REQUEST,
        FETCH_MANAGEMENT_NEWS_PERMISSION_SUCCESS,
        FETCH_MANAGEMENT_NEWS_PERMISSION_FAILURE,
      ],
    },
  };
}

/* 消息查詢單筆(管理畫面) */
export function fetchManagementNews(announcementId) {
  return {
    [CALL_API]: {
      url: `${NEWTUBE_API_SERVER}NewsCompany/Announcement/Management/V2/${announcementId}`,
      method: 'GET',
      headers: {
        functionCode: 'AnnouncementHR',
        actionCode: 'Manage',
      },
      types: [
        FETCH_MANAGEMENT_NEWS_REQUEST,
        FETCH_MANAGEMENT_NEWS_SUCCESS,
        FETCH_MANAGEMENT_NEWS_FAILURE,
      ],
    },
  };
}

/* 新增單筆 */
export function postManagementNews(data) {
  return {
    [CALL_API]: {
      url: `${NEWTUBE_API_SERVER}NewsCompany/Announcement/Management`,
      method: 'POST',
      params: data,
      headers: {
        functionCode: 'AnnouncementHR',
        actionCode: 'Manage',
      },
      types: [
        POST_MANAGEMENT_NEWS_REQUEST,
        POST_MANAGEMENT_NEWS_SUCCESS,
        POST_MANAGEMENT_NEWS_FAILURE,
      ],
    },
  };
}

/* 修改單筆 */
export function putManagementNews(announcementId, data) {
  return {
    [CALL_API]: {
      url: `${NEWTUBE_API_SERVER}NewsCompany/Announcement/Management/${announcementId}`,
      method: 'PUT',
      params: data,
      headers: {
        functionCode: 'AnnouncementHR',
        actionCode: 'Manage',
      },
      types: [
        PUT_MANAGEMENT_NEWS_REQUEST,
        PUT_MANAGEMENT_NEWS_SUCCESS,
        PUT_MANAGEMENT_NEWS_FAILURE,
      ],
    },
  };
}

/* 刪除消息 */
export function deleteManagementNews(announcementId) {
  return {
    [CALL_API]: {
      url: `${NEWTUBE_API_SERVER}NewsCompany/Announcement/Management/${announcementId}`,
      method: 'DELETE',
      headers: {
        functionCode: 'AnnouncementHR',
        actionCode: 'Manage',
      },
      types: [
        DELETE_MANAGEMENT_NEWS_REQUEST,
        DELETE_MANAGEMENT_NEWS_SUCCESS,
        DELETE_MANAGEMENT_NEWS_FAILURE,
      ],
    },
  };
}

/* 上傳附件 */
export function uploadManagementNewsFile(announcementId, formData) {
  return {
    [CALL_API]: {
      url: `${NEWTUBE_API_SERVER}NewsCompany/Announcement/Management/V2/${announcementId}/Attachment`,
      method: 'POST',
      headers: {
        functionCode: 'AnnouncementHR',
        actionCode: 'Manage',
      },
      types: [
        UPLOAD_MANAGEMENT_NEWSFILE_REQUEST,
        UPLOAD_MANAGEMENT_NEWSFILE_SUCCESS,
        UPLOAD_MANAGEMENT_NEWSFILE_FAILURE,
      ],
      contentType: CONTENT_TYPE.FORM,
      params: formData,
    },
  };
}

/* 刪除附件 */
export function deleteManagementNewsFile(announcementId, attachmentId) {
  return {
    [CALL_API]: {
      url: `${NEWTUBE_API_SERVER}NewsCompany/Announcement/Management/V2/${announcementId}/Attachment/${attachmentId}`,
      method: 'DELETE',
      headers: {
        functionCode: 'AnnouncementHR',
        actionCode: 'Manage',
      },
      types: [
        DELETE_MANAGEMENT_NEWSFILE_REQUEST,
        DELETE_MANAGEMENT_NEWSFILE_SUCCESS,
        DELETE_MANAGEMENT_NEWSFILE_FAILURE,
      ],
    },
  };
}

/* 管理介面取得報名資訊 */
export function fetchManagementEnrollment(announcementId) {
  return {
    [CALL_API]: {
      url: `${NEWTUBE_API_SERVER}NewsCompany/Enrollment/Management/?AnnouncementId=${announcementId}`,
      method: 'GET',
      headers: {
        functionCode: 'AnnouncementHR',
        actionCode: 'Manage',
      },
      types: [
        FETCH_MANAGEMENT_ENROLLMENT_REQUEST,
        FETCH_MANAGEMENT_ENROLLMENT_SUCCESS,
        FETCH_MANAGEMENT_ENROLLMENT_FAILURE,
      ],
    },
  };
}

/* 下載報表清冊 */
export function downloadManagementEnrollment(announcementId) {
  const downloadUrl = `${NEWTUBE_API_SERVER}NewsCompany/Enrollment/Management/ExcelReport?AnnouncementId=${announcementId}`;
  const types = [
    GET_DOWNLOADEXCEL_MANAGEMENTENROLLMENT_REQUEST,
    GET_DOWNLOADEXCEL_MANAGEMENTENROLLMENT_SUCCESS,
    GET_DOWNLOADEXCEL_MANAGEMENTENROLLMENT_ERROR,
  ];
  return downloadFile(
    downloadUrl,
    types,
    undefined,
    'GET',
    'AnnouncementHR',
    'Manage'
  );
}

/* 下載附件 */
export function downloadAnnouncementFile(apiUrl) {
  const fetchOptions = {
    mode: 'cors',
    method: 'GET',
    headers: {},
  };
  let downloadUrl = apiUrl.split('api/')[1];
  fetchOptions.headers['Content-Type'] = 'application/json';
  downloadUrl = `${NEWTUBE_API_SERVER}${downloadUrl}`;
  return fetchData(downloadUrl, fetchOptions);
}

/* 修改公司消息分類列表 (企業專區)*/
// export function putManagementNewsCategory(data) {
//   return {
//     [CALL_API]: {
//       url: `${NEWTUBE_API_SERVER}NewsCompany/AnnouncementCategory/Management`,
//       method: 'PUT',
//       params: data,
//       types: [
//         PUT_MANAGEMENT_NEWSCATEGORY_REQUEST,
//         PUT_MANAGEMENT_NEWSCATEGORY_SUCCESS,
//         PUT_MANAGEMENT_NEWSCATEGORY_FAILURE,
//       ],
//     },
//   };
// }



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/containers/App/screens/Tube/screens/CompanyNews/screens/NewsManagement/reducers/index.js
 **/